import React from "react";
import ImageLinksDiv from "./ImageLinksDiv.js";

/**
 * This is the modal that appears when an InternationalPost is clicked.
 * It contains the PostInternationalLinks component, which contains all the links,
 * as a child.
 */

const ImageLinksModal = ({ post, onClose, imageLinksData }) => {
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("modal-overlay")) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img
          className="modal-primary-img"
          id={post.id}
          src={post.app_thumbnail_url}
          alt={post.id}
        ></img>
        <div className="modal-verbiage">
          <p>
            <strong>TAP ANY PIC TO SHOP</strong>
          </p>
          <div className="paid-links">
            <p>
              <center>Paid Links</center>
            </p>
          </div>
        </div>

        {<ImageLinksDiv post={post} imageLinksData={imageLinksData} />}
        <button
          className="close-button-container"
          onClick={onClose}
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
  );
};

export default ImageLinksModal;
